/**
 * FashPlayResult Component
 * FashPlay video sonuç ekranı
 */

import React from 'react';
import { TopNavBar, WaitingTab } from '../../WaitingScreen/TopNavBar/TopNavBar';
import { MyCombinations } from '../../WaitingScreen/Tabs/MyCombinations';
import { UserProfile } from '../../WaitingScreen/Tabs/UserProfile';
import { RunwayPlayer } from '../../../Pages/FashPlay/components/RunwayPlayer';
import { VideoFeedbackButtons } from '../../../Pages/FashPlay/components/VideoFeedbackButtons';
import { DislikeReasonModal } from '../../../Pages/FashPlay/components/DislikeReasonModal';

export interface FashPlayResultProps {
    videoUrl: string | null;
    activeTab: WaitingTab;
    onTabChange: (tab: WaitingTab) => void;
    onLike: () => void;
    onDislike: () => void;
    storedUserId?: string;
    userStats?: { age?: number; height?: number; weight?: number };
    gender?: string | null;
    selectedBodyType?: string | null;
    avatarUrl?: string | null;
    onCreateNewAvatar: () => void;
    showDislikeModal: boolean;
    onCloseDislikeModal: () => void;
    onDislikeReasonSelect: (reason: string) => void;
    isRegenerating: boolean;
}

export const FashPlayResult: React.FC<FashPlayResultProps> = ({
    videoUrl,
    activeTab,
    onTabChange,
    onLike,
    onDislike,
    storedUserId,
    userStats,
    gender,
    selectedBodyType,
    avatarUrl,
    onCreateNewAvatar,
    showDislikeModal,
    onCloseDislikeModal,
    onDislikeReasonSelect,
    isRegenerating
}) => {
    return (
        <div className="fashplay-result-screen">
            <TopNavBar
                activeTab={activeTab}
                onTabChange={onTabChange}
                productName="Video"
            />
            
            <div className="fashplay-result-content">
                {activeTab === 'product' && (
                    <div className="fashplay-video-wrapper">
                        {videoUrl && (
                            <RunwayPlayer videoUrl={videoUrl} />
                        )}
                        <VideoFeedbackButtons
                            onLike={onLike}
                            onDislike={onDislike}
                        />
                    </div>
                )}
                
                {activeTab === 'my_combinations' && storedUserId && (
                    <MyCombinations
                        userId={storedUserId}
                    />
                )}
                
                {activeTab === 'profile' && (
                    <UserProfile
                        metadata={{
                            age: userStats?.age,
                            height: userStats?.height,
                            weight: userStats?.weight,
                            gender: gender,
                            bodyType: selectedBodyType
                        }}
                        avatarUrl={avatarUrl || undefined}
                        onCreateNewAvatar={onCreateNewAvatar}
                    />
                )}
            </div>

            <DislikeReasonModal
                isOpen={showDislikeModal}
                onClose={onCloseDislikeModal}
                onReasonSelect={onDislikeReasonSelect}
                isLoading={isRegenerating}
            />
        </div>
    );
};

export default FashPlayResult;
